import Select from "./Select";

import { ReactComponent as SignManIcon } from 'icons/components/signMan.svg';
import { ReactComponent as SignWomanIcon } from 'icons/components/signWoman.svg';

import config from "config";

export default class SexSelect extends Select {
    static propTypes = {
        ...Select.propTypes,
    };
    static defaultProps = {
        ...Select.defaultProps,
        items: config.sexes,
        placeHolder: "main.notIndicated",
        translate: true,
    };

    checkSelectedValue({ index }, { value, items }) {
        for (let i in items) {
            const item = items[i];

            if (item.id === value) {
                index = parseInt(i);
                break;
            }
        }
        
        this.state.index = index;
        return index;
    }

    getLeftIcon() {
        const { value } = this.props;

        if (value === 0)
            return <SignManIcon />;
        if (value === 1)
            return <SignWomanIcon />;

        return "";
    }
}
